module.exports = __webpack_public_path__ + "static/media/WIND3.698c3aef.svg";